module.exports = __webpack_public_path__ + "img/Airbnb-Sensory-Overload-Protect-Ears-20-20-20.c6c10a60.png";